import { HStack, Text , TextProps } from "@chakra-ui/react";
import React, { ReactNode } from "react";
import ErrorIcon from "../icons/ErrorIcon";

export type InputErrorVariant = "text" | "contained";

const InputError = ({
  children,
  variant = "text",
  ...props
}: {
  children: ReactNode;
} & TextProps & { variant?: InputErrorVariant }) => {
  if (variant === "text") {
    return (
      <Text color="caution" fontSize="sm" {...props}>
        {children}
      </Text>
    );
  } else {
    return (
      <HStack
        gap={"6px"}
        bgColor={"background.caution"}
        px={3}
        py={2}
        borderRadius="4px"
        {...props}
      >
        <ErrorIcon boxSize={5} color={"caution"} />
        <Text color="caution" fontSize="sm" pt={"1px"}>
          {children}
        </Text>
      </HStack>
    );
  }
};

export default InputError;
